import { precacheSurveyMediaFromPayload } from "./precacheSurveyMedia";
import { putSurveySnapshot } from "./surveyOfflineDb";

async function runPool(items, limit, fn) {
    let i = 0;
    async function worker() {
        while (i < items.length) {
            const idx = i;
            i += 1;
            await fn(items[idx]);
        }
    }
    const n = Math.min(limit, Math.max(1, items.length));
    await Promise.all(Array.from({ length: n }, () => worker()));
}

/**
 * Фоновая предзагрузка get_survey по уникальным survey_id из напоминаний.
 */
export async function prefetchSurveysForOffline(reminders, getAuthorized) {
    if (!reminders?.length || (typeof navigator !== "undefined" && !navigator.onLine)) return;

    const ids = [...new Set(reminders.map((r) => r.survey_id).filter(Boolean))];
    if (!ids.length) return;

    await runPool(ids, 3, async (surveyId) => {
        try {
            const response = await getAuthorized("/client/get_survey", {
                params: { survey_id: surveyId },
            });
            const data = response.data;
            if (data?.questions) {
                await putSurveySnapshot(surveyId, data);
                await precacheSurveyMediaFromPayload(data);
            }
        } catch {
            /* ignore single failure */
        }
    });
}
